export default "__VITE_ASSET__DD852bfH__"